const DotsGrid = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 4.5C9.91421 4.5 10.25 4.16421 10.25 3.75C10.25 3.33579 9.91421 3 9.5 3C9.08579 3 8.75 3.33579 8.75 3.75C8.75 4.16421 9.08579 4.5 9.5 4.5Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 9.75C9.91421 9.75 10.25 9.41421 10.25 9C10.25 8.58579 9.91421 8.25 9.5 8.25C9.08579 8.25 8.75 8.58579 8.75 9C8.75 9.41421 9.08579 9.75 9.5 9.75Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 15C9.91421 15 10.25 14.6642 10.25 14.25C10.25 13.8358 9.91421 13.5 9.5 13.5C9.08579 13.5 8.75 13.8358 8.75 14.25C8.75 14.6642 9.08579 15 9.5 15Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.75 4.5C15.1642 4.5 15.5 4.16421 15.5 3.75C15.5 3.33579 15.1642 3 14.75 3C14.3358 3 14 3.33579 14 3.75C14 4.16421 14.3358 4.5 14.75 4.5Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.75 9.75C15.1642 9.75 15.5 9.41421 15.5 9C15.5 8.58579 15.1642 8.25 14.75 8.25C14.3358 8.25 14 8.58579 14 9C14 9.41421 14.3358 9.75 14.75 9.75Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.75 15C15.1642 15 15.5 14.6642 15.5 14.25C15.5 13.8358 15.1642 13.5 14.75 13.5C14.3358 13.5 14 13.8358 14 14.25C14 14.6642 14.3358 15 14.75 15Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 4.5C4.66421 4.5 5 4.16421 5 3.75C5 3.33579 4.66421 3 4.25 3C3.83579 3 3.5 3.33579 3.5 3.75C3.5 4.16421 3.83579 4.5 4.25 4.5Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 9.75C4.66421 9.75 5 9.41421 5 9C5 8.58579 4.66421 8.25 4.25 8.25C3.83579 8.25 3.5 8.58579 3.5 9C3.5 9.41421 3.83579 9.75 4.25 9.75Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.25 15C4.66421 15 5 14.6642 5 14.25C5 13.8358 4.66421 13.5 4.25 13.5C3.83579 13.5 3.5 13.8358 3.5 14.25C3.5 14.6642 3.83579 15 4.25 15Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DotsGrid;
